export const locale = {
  lang: 'it',
  data: {
    'TOOLBAR': {
      'USER': {
        'PROFILE': 'Profilo personale',
        'EXIT': 'Esci'
      },
      'LOGOUT': {
        'CONFIRM': 'Confermare',
        'MESSAGE': 'Sei sicuro di voler uscire dall\'applicazione?',
        'CANCEL': 'Annulla',
        'EXIT': 'Esci dall\'applicazione'
      }
    },
    'START_ONBOARDING': 'Avvia',
    'RESUME_ONBOARDING': 'Riprendi'
  }
};
